import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { checkAuthState } from '../utils/APIUtils';
import { getMFAStatus } from '../utils/mfaUtils';
import { decryptLocalStorage } from '../utils/authUtils';
import { USER } from '../constants/CommonConst';
import { CircularProgress } from '@material-ui/core';

const MFAGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [mfaCheckComplete, setMfaCheckComplete] = useState(false);
  const location = useLocation();

  useEffect(() => {
    checkMFARequirement();
  }, [location.pathname]);

  const checkMFARequirement = async () => {
    try {
      // Always allow access to MFA setup page to prevent infinite loops
      // if (location.pathname === '/mfa-setup') {
      //   setMfaCheckComplete(true);
      //   setLoading(false);
      //   return;
      // }

      const user = decryptLocalStorage(USER);
      if (!user) {
        setLoading(false);
        setMfaCheckComplete(true);
        return;
      }

      // Check if user is SUPER_ADMIN - bypass MFA requirements
      const cognitoUser = await checkAuthState();
      if (user.role === 'SUPER_ADMIN' || cognitoUser?.attributes?.['custom:role'] === 'SUPER_ADMIN') {
        setMfaCheckComplete(true);
        setLoading(false);
        return;
      }

      // Check if MFA is enforced for this user from getUserById response
      if (user.mfaEnforced === true) {
        // Check if user already has MFA enabled in Cognito
        const currentMfaStatus = await getMFAStatus();
        
        if (!currentMfaStatus.enabled) {
          // User needs to set up MFA - redirect to MFA setup
          // history.push('/mfa-setup?required=true');
          // return;
          
          setMfaCheckComplete(true);
          setLoading(false);
          return;
        }
      }

      // MFA check passed - allow access
      setMfaCheckComplete(true);
      setLoading(false);
    } catch (error) {
      console.error('Error checking MFA requirement:', error);
      // On error, allow access but log the issue
      setMfaCheckComplete(true);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column'
      }}>
        <CircularProgress />
        <p style={{ marginTop: '20px', color: '#666' }}>Checking security requirements...</p>
      </div>
    );
  }

  return mfaCheckComplete ? children : null;
};

export default MFAGuard;
